import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import Button from "@components/button";

const LOAD_STATUS = {
  loading: "__LOADING__",
  success: "__SUCCESS__",
  error: "__ERROR__",
  pending: "__PENDING__",
};

export default class Image extends React.Component {
  constructor(props) {
    super();
    this.state = {
      status: LOAD_STATUS.loading,
      loadit: props.loadit,
    };
    this.__img__ = React.createRef();
  }
  getImage() {
    return this.__img__.current;
  }
  componentDidMount() {
    const img = this.getImage();
    if (!!img && !!img.src) {
      img.complete ? this.success() : this.IE9IntervalChecking(img); // IE9 304图片，不触发onload，其实，也不一定是IE9，也是有某种奇葩情况
    }
  }
  IE9IntervalChecking(img) {
    requestAnimationFrame(() => (img.complete ? this.success() : setTimeout(() => this.IE9IntervalChecking(img), 10)));
  }
  success() {
    // requestAnimationFrame(() => this.setState({ status: LOAD_STATUS.success }));
    this.setState({ status: LOAD_STATUS.success });
  }
  componentWillReceiveProps(nextProps) {
    this.setState({
      loadit: nextProps.loadit && this.state.status !== LOAD_STATUS.success, // 即使error，下次再试着加载
    });
  }
  render() {
    const { className, src, title, children, isFull } = this.props;
    const { loadit, status } = this.state;
    const isLoaded = !!src && status === LOAD_STATUS.success;
    const isErr = !!src && loadit && status === LOAD_STATUS.error;
    const isPending = status === LOAD_STATUS.pending;
    const isLoading = !!src && loadit && !isLoaded && !isErr && !isPending;
    const pending = !loadit && !isLoaded;

    const cls = cx("x-image", className, {
      "x-loading": isLoading,
      "x-pending": pending,
      "x-error": isErr,
      full: isFull,
    });
    return (
      <figure className={cls}>
        <img
          className="m"
          ref={this.__img__}
          title={title}
          alt={title}
          src={isLoading || isLoaded ? src : null}
          onLoad={() => this.success()}
          onError={() => this.setState({ status: LOAD_STATUS.error })}
        />
        {isErr && (
          <figcaption>
            图片加载失败
            <Button
              btnType="blue"
              btnSize="sm"
              onClick={e => {
                e.stopPropagation();
                e.nativeEvent.stopImmediatePropagation();
                e.preventDefault();
                this.setState({ status: LOAD_STATUS.loading });
              }}
            >
              重试
            </Button>
          </figcaption>
        )}
        {children}
        <s className="img-loader">
          <i />
        </s>
      </figure>
    );
  }
}

const { string, bool, any } = PropTypes;
Image.propTypes = {
  className: string,
  src: string.isRequired,
  title: string,
  loadit: bool,
  children: any,
  isFull: bool,
};

Image.defaultProps = {
  className: "",
  title: "",
  loadit: false,
  children: null,
  isFull: false,
};

require("./index.less");
require("./index.less");